import { EMPTY_TRANSLATIONS } from "src/globalConsts";
import type { DataTemplateItem } from "./dataTemplateItems";
import { columnFormatPLACEHOLDER } from "../../templates/types/placeholderData/columnFormat";
import {
  PresentationTemplateItem,
  PresentationTemplateItemType,
} from "./presentationTemplateItems";

export const dataTemplateItemPLACEHOLDER: DataTemplateItem = {
  order: 0,
  type: "empty",
  tableName: "",
  column: "",
  sqlColumn: "",
  joinSqlColumn: "",
  sqlDisplayColumn: "",
  aliasDisplayColumn: "",
  aliasTableName: "",
  globalId: 0,
  displayColumn: "",
  topParentId: 0,
  join: 0,
  parent: 0,
  isBase: false,
  joinType: "none",
  joinTypeVisible: false,
  newWhereItems: [],
  tableId: 0,
  tableSchema: "",
  existingJoinItemId: null,
  isEditableExtension: false,
  sqlType: "",
};

export const presentationTemplateItemPLACEHOLDER: PresentationTemplateItem = {
  editable: true,
  id: 0,
  overviewSelectTemplateId: null,
  displayColumnName: "",
  type: PresentationTemplateItemType.Value,
  selectItems: [],
  aggregationGroupId: 0,
  columnFormat: columnFormatPLACEHOLDER,
  columnFormatMobile: columnFormatPLACEHOLDER,
  columnOrder: 0,
  columnLink: null,
  prefillRules: [],
  overviewSelectPrefillRules: [],
  disableTriggerEvents: false,
  translations: EMPTY_TRANSLATIONS,
};
